import { render, staticRenderFns } from "./TipoLicenciaModalNuevo.vue?vue&type=template&id=490dc685&scoped=true&"
import script from "./TipoLicenciaModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipoLicenciaModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./TipoLicenciaModalNuevo.vue?vue&type=style&index=0&id=490dc685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490dc685",
  null
  
)

export default component.exports